<template>
  <div id="app">
    <div v-if="done">
      <Layout />
      <!-- <ChatBot /> -->
      <div v-if="$global.isLoading" class="loading-global">
        <i class="fa fa-spinner fa-pulse fa-spin font-40 text-white" />
      </div>
    </div>
    <div
      v-else
      style="height: 100lvh"
      class="flex align-items-center justify-content-center"
    >
      <p>Tải nội dung: {{ percent }}%</p>
      <div class="box box-200 mt-1">
        <div
          class="flex flex-row"
          style="overflow: hidden; border-radius: 10px"
        >
          <div
            :class="
              'bg-main flex flex-' + $formatQuantity(percent, false, true)
            "
            style="height: 10px"
          />
          <div
            :class="
              'bg-white flex flex-' +
              $formatQuantity(100 - percent, false, true)
            "
            style="height: 10px"
          />
        </div>
      </div>

      <button class="btn btn-primary-outline mt-5" @click="logout()">
        Đăng nhập với tài khoản khác
      </button>
    </div>

    <NewIncomeExpense ref="newIncome" />

    <PaymentOrderList ref="paymentOrderList" />
    <FilterSide ref="filterSide" />
    <SelectProduct ref="selectProduct" />
    <SelectStock ref="selectStock" />
    <SelectCustomer ref="selectCustomer" />
    <SelectEmployee ref="selectEmployee" />
    <SelectSupplier ref="selectSupplier" />

    <Notification />
    <FormPopup ref="formPopup" />
    <QuickView />
    <DetailQuickView ref="detail" />
    <ConfirmPopup />
    <QuickViewIncome ref="quickViewIncome" />
    <Popup ref="popup" />
  </div>
</template>

<script>
import Layout from "./components/Layout.vue"
import ChatBot from "./components/ChatBot.vue"
import Vue from "vue"
import _ from "lodash"
import FormPopup from "./components/FormPopup.vue"
import DetailQuickView from "@/components/DetailQuickView"
import QuickView from "./components/QuickView.vue"
import ConfirmPopup from "./components/ConfirmPopup.vue"
import Notification from "./components/Notification.vue"
import MoneyInput from "./components/MoneyInput"
import QuantityInput from "./components/QuantityInput"
import CheckBox from "./components/CheckBox"
import Options from "./components/Options"
import DataTable from "./components/DataTable.vue"
import DataTableLocal from "./components/DataTableLocal.vue"
import Switch from "./components/Switch"
import Radio from "./components/Radio"
import Lines from "./components/Lines"
import CustomFields from "./components/CustomFields"
import FormData from "./components/FormData"
import AutoComplete from "./components/AutoComplete"

import QuickViewIncome from "@/components/QuickViewIncome"
import NewIncomeExpense from "@/components/NewIncomeExpense"

import VueBarcode from "vue-barcode"
import JsonExcel from "vue-json-excel"

import { resetData } from "./services/common"

import * as api from "./services/api"
import FilterSide from "./components/FilterSide.vue"
import SelectProduct from "./components/SelectProduct.vue"
import SelectCustomer from "./components/SelectCustomer.vue"
import SelectEmployee from "./components/SelectEmployee.vue"
import SelectSupplier from "./components/SelectSupplier.vue"
import SelectStock from "./components/SelectStock.vue"
import moment from "moment"
import PaymentOrderList from "./components/PaymentOrderList.vue"
import { uploadFile } from "@/services/common"
import Popup from "./components/Popup.vue"

const METRIC = [
  { divider: 1e18, suffix: "E" },
  { divider: 1e15, suffix: "P" },
  { divider: 1e12, suffix: "T" },
  { divider: 1e9, suffix: "G" },
  { divider: 1e6, suffix: "M" },
  { divider: 1e3, suffix: "K" },
]

Vue.prototype.$api = api
Vue.prototype.$moment = moment
Vue.prototype._ = _
Vue.prototype.$global = Vue.observable({
  setLoading(value) {
    this.isLoading = !!value
  },
  isLoading: false,
})
Vue.prototype.$copyObject = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

//console.log(process.env);

Vue.prototype.$formatMoney = (num, notZero, decimal = 1, noPrefix) => {
  const currencyDecimal = Vue.prototype.$currencyDecimal || 1
  if (decimal > 1) {
    num = Math.round(num * decimal) / decimal
  } else {
    num = Math.round(num * currencyDecimal) / currencyDecimal
  }
  if (notZero && (num == 0 || isNaN(num))) {
    return "-"
  }
  // num = Math.abs(num);
  const parts = num ? num.toString().split(".") : ["0"]
  parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  var out = parts.join(".")
  if (noPrefix) {
    return out
  }
  return out + "" + Vue.prototype.$currencySymbol
}

Vue.prototype.$formatNumber = (num, notZero, decimal = 1) => {
  const currencyDecimal = Vue.prototype.$currencyDecimal || 1
  if (decimal > 1) {
    num = Math.round(num * decimal) / decimal
  } else {
    num = Math.round(num * currencyDecimal) / currencyDecimal
  }
  if (notZero && (num == 0 || isNaN(num))) {
    return "-"
  }
  const parts = num ? num.toString().split(".") : ["0"]
  parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  return parts.join(".")
}

Vue.prototype.$genCode = (
  name,
  data = {
    count: 0,
    countByOrder: 0,
    countByDate: 0,
    countByContract: 0,
    BRANCH_CODE: Vue.prototype.$branch.branchCode || "",
    COMPANY_CODE: Vue.prototype.$company.companyCode || "",
  },
) => {
  const codeTemplate = Vue.prototype.$codeTemplate[name] || ""
  let code = codeTemplate

  if (code.indexOf("${DATE:") > -1) {
    const dateFormat = code.match(/\${DATE:(.*?)}/)[1]
    code = code.replace(
      /\${DATE:(.*?)}/,
      moment().format(dateFormat.replace(":", "")),
    )
  }

  data["COMPANY_CODE"] = Vue.prototype.$company.companyCode || ""
  for (let i = 2; i <= 8; i++) {
    const pad = (num) => ("0".repeat(i) + num).slice(-i)
    data[`NUMBER:${i}`] = pad(data.count)
    data[`NUMBER_DATE:${i}`] = pad(data.countByDate)
    data[`NUMBER_ORDER:${i}`] = pad(data.countByOrder)
    data[`NUMBER_CONTRACT:${i}`] = pad(data.countByContract)
  }

  Object.keys(data).forEach((key) => {
    const k = "${" + key + "}"
    code = code.replace(k, data[key] || "")
  })

  code = code.replace(/--/g, "-").replace(/__/g, "_")
  code = code.replace(/--/g, "-").replace(/__/g, "_")
  code = code.replace(/--/g, "-").replace(/__/g, "_")
  code = code.replace(/--/g, "-").replace(/__/g, "_")
  return code.toUpperCase()
}

Vue.prototype.$formatCurrency = (num = 0, rate = 1, currency = "VND") => {
  rate = rate || 1
  currency = currency || Vue.prototype.$currencySymbol
  if (rate == 1) {
    return Vue.prototype.$formatMoney(num)
  }
  const exchangeRate = Vue.prototype.$exchangeList.find(
    (a) => a.currency == currency,
  )
  const symbol = exchangeRate?.symbol || currency

  const str = Vue.prototype.$formatMoney(num / rate, false, 1, true)

  return str + symbol
}

Vue.prototype.$shortName = function (name, length = 2) {
  if (!name) {
    return ""
  }

  const parts = name.trim().split(" ")
  if (parts.length == 1) {
    return name.slice(0, length).toUpperCase()
  } else {
    return parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase()
  }
}

Vue.prototype.$formatQuantity = (num, notZero, decimal = 100) => {
  num = Math.round(num * decimal) / decimal
  if (notZero && (num == 0 || isNaN(num))) {
    return "-"
  }
  const parts = num ? num.toString().split(".") : ["0"]
  parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  return parts.join(".")
  // (noPrefix ? "" : "₫")
}

String.prototype.insert = function (index, string) {
  if (index > 0) {
    return this.substring(0, index) + string + this.substr(index)
  }

  return string + this
}
Vue.prototype.$unitFormat = (value, unitName) => {
  var units = Vue.prototype.$units
  var u = units.find((a) => a.name == unitName)

  var out = Vue.prototype.$formatQuantity(value) + " " + unitName

  if (u && u.transferUnits && u.transferUnits.length) {
    u.transferUnits
      .sort((a, b) => a.transferValue - b.transferValue)
      .map((tr) => {
        var v = Math.floor(value / tr.transferValue)
        if (v >= 1) {
          var s = Vue.prototype.$formatQuantity(v) + " " + tr.transferName
          if (value % tr.transferValue == 0) {
            out += `<p class="sub-text">= ${s}</p>`
          } else {
            var s2 =
              Vue.prototype.$formatQuantity(value % tr.transferValue) +
              " " +
              unitName
            out += `<p class="sub-text">= ${s} ${s2}</p>`
          }
        }
      })
  }

  return out
}

Vue.prototype.$formatTime = (date) => {
  // const d = date ? new Date(date) : new Date()
  // return (
  //   ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2)
  // )

  return date ? moment(date).format("HH:mm") : "-"
}
Vue.prototype.$toNumber = (str) => {
  return str ? str.match(/[0-9]+/g).join("") : ""
}

Vue.prototype.$getElementCode = (code) => {
  const elementSaleCode = Vue.prototype.$financeAuto.find(
    (a) => a.keyPayment == code,
  )?.elementCode
  const element =
    Vue.prototype.$financeCodes.find((a) => a.code == elementSaleCode) || {}
  return element
}

Vue.prototype.$toDate = (str) => {
  return new Date(str)
}

Vue.prototype.$formatDate = (date) => {
  const d = date ? new Date(date) : new Date()
  return (
    d.getFullYear() +
    "-" +
    ("00" + (d.getMonth() + 1)).slice(-2) +
    "-" +
    ("00" + d.getDate()).slice(-2)
  )
}

Vue.prototype.$formatFullDate = (date) => {
  const d = date ? new Date(date) : new Date()
  return moment(d).format("YYYY-MM-DD | HH:mm")
}

Vue.prototype.$sum = (arr = [], key) => {
  let total = 0
  arr.map((item) => {
    total += key ? item[key] : item
  })
  return +total || 0
}

Vue.prototype.$isMobile = () => {
  return window.innerWidth <= 768
}
Vue.prototype.$getMetric = (number) => {
  for (var i = 0; i < METRIC.length; i++) {
    if (number >= METRIC[i].divider) {
      return (number / METRIC[i].divider).toString() + METRIC[i].suffix
    }
  }
  return number.toString()
}

Vue.prototype.$makeid = (length = 6) => {
  var result = ""
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

Vue.prototype.$changeAlias = (alias) => {
  let str = alias
  str = str.toLowerCase()
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i")
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
  str = str.replace(/đ/g, "d")
  str = str.replace(/ + /g, " ")
  str = str.trim()
  return str
}

Vue.prototype.$formatInput = (inputs, name) => {
  const defaultKey = "FIELD_" + name;
  const roleKey = "FIELD_" + name + "_" + this.$user.roleId;
  const d = Vue.prototype.$company[roleKey] || Vue.prototype.$company[defaultKey]
  if (d) {
    const tableField = JSON.parse(d)
    // console.log("Table field config for", name, tableField)
    const inputs2 = inputs
      .filter((a) => a)
      .map((input, idx) => {
        const found = tableField
          .filter((a) => a)
          .find((f) => f.key == input.key)
        if (found) {
          input.hide = found.hide || false
          input.width = found.width || input.width
          input.title = found.title || input.title
          input.index = found.index || input.index || idx
          input.required = found.required || false
          input.format = found.format || input.format
          input.regex = found.regex || input.regex
          input.disabled = found.disabled || false
          input.tab = found.tab || input.tab
        }
        input.tableConfig = input.tableConfig || {
          allowNew: true,
          allowDelete: true,
        }
        return input
      })
      .filter((i) => !i.hide)
    inputs2.sort((a, b) => {
      return (a.index || 0) - (b.index || 0)
    })
    return inputs2
  }
  return inputs
}

Vue.prototype.$formatActionsTable = (actions, name) => {
  if (Vue.prototype.$company["TABLE_ACTION_" + name]) {
    const actionConfig = JSON.parse(
      Vue.prototype.$company["TABLE_ACTION_" + name],
    )
    const actions2 = actions
      .filter((a) => a)
      .map((action, idx) => {
        const found = actionConfig
          .filter((a) => a)
          .find((f) => f.key == action.key)
        if (found) {
          action.hide = found.hide || false
          action.index = found.index || action.index || idx
          action.name = found.name || action.name
          action.icon = found.icon || action.icon
          action.tooltip = found.tooltip || action.tooltip
        }
        return action
      })
      .filter((i) => !i.hide)
    actions2.sort((a, b) => {
      return (a.index || 0) - (b.index || 0)
    })
    return actions2.filter((a) => a.hide !== true)
  }
  return actions
}

Vue.prototype.$formatColumns = (columns, name) => {
  if (Vue.prototype.$company["TABLE_FIELD_" + name]) {
    const tableField = JSON.parse(Vue.prototype.$company["TABLE_FIELD_" + name])
    const tableFieldClone = _.cloneDeep(tableField)
    const columns2 = [
      ...columns,
      ...tableField.filter(
        (a) => a.key.indexOf("new_field_") === 0 || a.isCustom,
      ),
    ]
      .map((column, idx) => {
        const found = tableFieldClone
          .filter((a) => a)
          .find((f) => f.key == column.key)
        column.hide = false
        if (found) {
          column.hide = found.hide || false
          column.width = found.width || column.width
          column.title = found.title || column.title
          column.index = found.index || idx
          column.pattern = found.pattern || column.pattern
          column.className += " " + (found.className || "")
          column.searchType = found.searchType || column.searchType
          column.searchKey = found.searchKey || column.searchKey
          column.description = found.description || column.description

          if (column.pattern) {
            column.showData = (record) => {
              const t = column.pattern.replace(/\$(.*?)\$/g, (_name, key) => {
                return _.get(record, key) || ""
              })
              return t
            }
          }
        }
        return column
      })
      .filter((i) => !i.hide)
    columns2.sort((a, b) => {
      return (a.index || 0) - (b.index || 0)
    })
    return columns2
  }
  return columns
}

Vue.prototype.$back = () => {
  history.back()
}
Vue.prototype.$shortcutDateRangeFuture = [
  {
    text: "Tuần sau",
    onClick() {
      const curr = new Date()
      const first =
        curr.getDate() - curr.getDay() + (curr.getDay() == 0 ? -6 : 1)
      const last = first + 6
      const start = new Date(curr.setDate(first + 7))
      const end = new Date(curr.setDate(last + 7))
      return [start, end]
    },
  },
  {
    text: "Tháng sau",
    onClick() {
      const date = new Date()
      const start = new Date(date.getFullYear(), date.getMonth() + 1, 1)
      const end = new Date(date.getFullYear(), date.getMonth() + 2, 0)
      return [start, end]
    },
  },
  {
    text: "Năm sau",
    onClick() {
      const date = new Date()
      const start = new Date(date.getFullYear() + 1, 0, 1)
      const end = new Date(date.getFullYear() + 2, 0, 0)
      return [start, end]
    },
  },
  {
    text: "Hôm nay tới cuối tuần",
    onClick() {
      const today = new Date()
      const curr = new Date()
      const first =
        curr.getDate() - curr.getDay() + (curr.getDay() == 0 ? -6 : 1)
      const last = first + 6
      // const start = new Date(curr.setDate(first));
      const end = new Date(curr.setDate(last))
      return [today, end]
    },
  },
  {
    text: "Hôm nay tới cuối tháng",
    onClick() {
      const date = new Date()
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return [date, end]
    },
  },
  {
    text: "Hôm nay tới cuối năm",
    onClick() {
      const date = new Date()
      const end = new Date(date.getFullYear() + 1, 0, 0)
      return [date, end]
    },
  },
]
Vue.prototype.$allMonth = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((m) => ({
  text: "Tháng " + m + "/" + moment().format("YYYY"),
  onClick() {
    return [
      moment("2022-" + m + "-01")
        .startOf("month")
        .toDate(),
      moment("2022-" + m + "-01")
        .endOf("month")
        .toDate(),
    ]
  },
}))

Vue.prototype.$clone = (a) => {
  return _.cloneDeep(a)
}

// Vue.prototype.$clone = (a) => {
//   const clone = (o) => {
//     if (o && typeof o == "object") {
//       if (Array.isArray(o)) {
//         return [...o.map((i) => clone(i))];
//       }
//       var out = {};
//       Object.keys(o).map((k) => {
//         out[k] = clone(o[k]);
//       });
//       return out;
//     }
//     return o;
//   };
//   return clone(a);
// };

Vue.prototype.$shortcutDateRange = [
  {
    text: "Hôm nay",
    onClick() {
      const curr = new Date()
      return [curr, curr]
    },
  },
  {
    text: "Tuần này",
    onClick() {
      const curr = new Date()
      const start = new Date(
        curr.setDate(
          curr.getDate() - curr.getDay() + (curr.getDay() == 0 ? -6 : 1),
        ),
      )
      const end = new Date(curr.setDate(curr.getDate() + 5))
      return [start, end]
    },
  },
  {
    text: "Tháng này",
    onClick() {
      const date = new Date()
      const start = new Date(date.getFullYear(), date.getMonth(), 1)
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return [start, end]
    },
  },
  {
    text: "Năm nay",
    onClick() {
      const date = new Date()
      const start = new Date(date.getFullYear(), 0, 1)
      const end = new Date(date.getFullYear() + 1, 0, 0)
      return [start, end]
    },
  },
  {
    text: "Tuần trước",
    onClick() {
      const curr = new Date()
      const start = new Date(curr.setDate(curr.getDate() - curr.getDay()))
      const end = new Date(curr.setDate(curr.getDate() + 6))
      return [start, end]
    },
  },
  {
    text: "Tháng trước",
    onClick() {
      const date = new Date()
      const start = new Date(date.getFullYear(), date.getMonth() - 1, 1)
      const end = new Date(date.getFullYear(), date.getMonth(), 0)
      return [start, end]
    },
  },
  {
    text: "Năm trước",
    onClick() {
      const curr = new Date()
      const start = new Date(curr.setFullYear(curr.getFullYear() - 1, 0, 1))
      const end = new Date(start.getFullYear(), 11, 31)
      return [start, end]
    },
  },
  {
    text: "Đầu tuần tới hôm nay",
    onClick() {
      const today = new Date()
      const curr = new Date()
      const first =
        curr.getDate() - curr.getDay() + (curr.getDay() == 0 ? -6 : 1)
      const start = new Date(curr.setDate(first))
      return [start, today]
    },
  },
  {
    text: "Đầu tháng tới hôm nay",
    onClick() {
      const date = new Date()
      const start = new Date(date.getFullYear(), date.getMonth(), 1)
      return [start, date]
    },
  },
  {
    text: "Đầu năm tới hôm nay",
    onClick() {
      const date = new Date()
      const start = new Date(date.getFullYear(), 0, 1)
      return [start, date]
    },
  },
]

Vue.prototype.$isInner = (str1, str2) => {
  const s1 = Vue.prototype.$changeAlias(str1 || "").toLowerCase()
  const s2 = Vue.prototype.$changeAlias(str2 || "").toLowerCase()
  if (!s2) {
    return true
  }
  if (s1.indexOf(s2) > -1) {
    return true
  } else {
    return false
  }
}

String.prototype.highlight = function (s) {
  var r = new RegExp(s, "gi")
  return s ? (this || "").replace(r, (a) => `<mark>${a}</mark>`) : this
}

Vue.prototype.$permission = (functions) => {
  if (!functions) {
    return false
  }
  let currentRoles = localStorage.getItem("currentRoles")
  currentRoles = JSON.parse(currentRoles) || []
  const functionList = functions.split(",")
  let out = false
  functionList.map((fx) => {
    let isGroup = false
    if (fx.indexOf(":") === -1) {
      isGroup = true
    }
    currentRoles.map((item) => {
      if (isGroup) {
        if (item.fxCode && item.fxCode.indexOf(fx) === 0) {
          out = true
        }
      } else {
        if (item.fxCode === fx) {
          out = true
        }
      }
    })
  })
  return out
}
Vue.prototype.$allLimit = [5, 10, 25, 50, 100, 1000]

Array.prototype.contains = function (v) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] === v) return true
  }
  return false
}

Array.prototype.search = function (key = "") {
  return this.filter(
    (a) => (a.name || "").toLowerCase().indexOf(key.toLowerCase()) > -1,
  )
}

Array.prototype.unique = function () {
  var arr = []
  for (var i = 0; i < this.length; i++) {
    if (!arr.contains(this[i])) {
      arr.push(this[i])
    }
  }
  return arr
}
Array.prototype.leftJoin = function (arr1, key, keep) {
  return this.filter(
    (s) => (keep && keep == s[key]) || !arr1.find((r) => r[key] == s[key]),
  )
}

Array.prototype.isDuplicate = function () {
  return new Set(this).size !== this.length
}
String.prototype.alias = function () {
  let str = this
  str = str.toLowerCase()
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a")
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e")
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i")
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o")
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u")
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y")
  str = str.replace(/đ/g, "d")
  str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "")
  str = str.replace(/ + /g, " ")
  str = str.trim()
  return str
}

Array.prototype.clone = function () {
  return JSON.parse(JSON.stringify(this))
}
Array.prototype.copy = function () {
  return JSON.parse(JSON.stringify(this))
}

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item)
}

String.prototype.next = function () {
  var str = this + ""
  var strs = str.split("")
  var newStrs = str.split("")

  var alphabet = "0123456789abcdefghijklmnopqrstuvwxyz".toUpperCase()
  // var alphabet = '0123456789'.toUpperCase();
  var next = (character) => {
    var current = alphabet.indexOf(character.toUpperCase())
    if (current == -1) {
      return character
    }
    if (current >= alphabet.length - 1) {
      current = 0
    } else {
      current = current + 1
    }
    return alphabet[current]
  }
  var isStop = false
  for (let i = strs.length - 1; i >= 0; i--) {
    if (!isStop) {
      newStrs[i] = next(strs[i])
      isStop = newStrs[i] > strs[i] ? true : false
    }
  }
  return newStrs.join("")
}
document.addEventListener("dragover", function (e) {
  e.preventDefault()
})

Array.prototype.switch = function (start, end) {
  var arr = this
  var tmp = arr[start]
  arr[start] = arr[end]
  arr[end] = tmp
  return arr
}
Array.prototype.max = function () {
  var arr = this
  if (!arr) {
    return null
  }
  // var minV = arr[0];
  var maxV = arr[0]
  for (let a of arr) {
    // if (a < minV) minV = a;
    if (a > maxV) maxV = a
  }
  return maxV
}

Vue.prototype.$round = function (e) {
  const decial = Vue.prototype.$currencyDecimal || 1
  return Math.round(e * decial) / decial
}

Array.prototype.mergeTotal = function (key, total) {
  var obj = {}
  var values = total.split(",")

  var _this = JSON.parse(JSON.stringify(this))

  for (var i = 0; i < _this.length; i++) {
    var item = _this[i]
    if (obj[item[key]]) {
      values.map((value) => {
        obj[item[key]][value] += item[value]
      })
    } else {
      var initObject = {
        ..._this[i],
      }
      values.map((value) => {
        initObject[value] = 0
      })
      obj[item[key]] = initObject

      values.map((value) => {
        obj[item[key]][value] += item[value]
      })
    }
  }
  return Object.keys(obj).map((i) => {
    return {
      ...obj[i],
    }
  })
}

Vue.prototype.$formatPercent = (num = 0) => {
  if (num == Infinity) {
    return "∞"
  }
  if (!num) {
    return ""
  }
  // if (num < 0) {
  //   num = num * -1;
  // }
  return Math.floor(num * 10000) / 100 + "%"
}

Vue.prototype.$customFieldsFormat = async (tableName, res, inputs = []) => {
  const customFieldValues = []
  const customFields = Vue.prototype.$customFields.filter(
    (a) => a.tableName == tableName,
  )
  // upload file

  for (const a of inputs) {
    if (
      (a.type == "file" || a.type == "image") &&
      typeof res[a.key] != "string"
    ) {
      var i2 = await uploadFile(res[a.key])
      res[a.key] = i2.fileDownloadUri
    }
    if (a.type == "files" || a.type == "images") {
      var files = []
      for (const f of res[a.key] || []) {
        if (typeof f != "string") {
          var i3 = await uploadFile(f)
          files.push(i3.fileDownloadUri)
        } else {
          files.push(f)
        }
      }
      res[a.key] = files
    }
  }
  for (const a of customFields) {
    if (
      (a.type == "file" || a.type == "image") &&
      typeof res["custom_" + a.code] != "string"
    ) {
      var i22 = await uploadFile(res["custom_" + a.code])
      res["custom_" + a.code] = i22.fileDownloadUri
    }
    if (a.type == "files" || a.type == "images") {
      var files2 = []
      for (const f of res["custom_" + a.code] || []) {
        if (typeof f != "string") {
          var i33 = await uploadFile(f)
          files2.push(i33.fileDownloadUri)
        } else {
          files2.push(f)
        }
      }
      res["custom_" + a.code] = files2
    }
  }

  customFields.forEach((a) => {
    const value = res["custom_" + a.code]
    if (typeof value == "object" || Array.isArray(value)) {
      let v = JSON.stringify(value)
      if (Array.isArray(value) && value.length == 0) {
        v = undefined
      }
      // if (v) {
      customFieldValues.push({
        fieldCode: a.code,
        value: v,
      })
      // }
    } else {
      customFieldValues.push({
        fieldCode: a.code,
        value: value,
      })
    }
    delete res["custom_" + a.code]
  })
  return {
    ...res,
    customFieldValues,
  }
}

Vue.prototype.$customFieldsToJson = (customFieldValues) => {
  const out = {}
  customFieldValues.map((a) => {
    if (a.fieldCode) {
      if (a.stringValue || a.value) {
        try {
          out[a.fieldCode] = JSON.parse(a.stringValue || a.value)
          if (Array.isArray(out[a.fieldCode])) {
            out[a.fieldCode + "_code"] = out[a.fieldCode]
              .map((i) => i.id || i.code || i)
              .join(", ")
            out[a.fieldCode + "_name"] = out[a.fieldCode]
              .map((i) => i.name || i.value || i)
              .join(", ")
            out[a.fieldCode + "_full"] = out[a.fieldCode]
              .map((i) =>
                `${i.code || i.id || i} - ${i.name || i.value || i}`.trim(),
              )
              .join(", ")
          }
        } catch (e) {
          out[a.fieldCode] = a.stringValue || a.value || undefined
        }
      } else {
        out[a.fieldCode] = a.numberValue || a.value || undefined
      }
    }
  })
  return out
}

Vue.prototype.$getMultiFieldLabel = (item) => {
  if (item && typeof item == "object") {
    return item.value || item.name || item.code || item.id || ""
  }
  return item || ""
}

Vue.prototype.$customFieldsInputs = (tableName, data = {}) => {
  let fields = Vue.prototype.$customFields.filter(
    (a) => a.tableName == tableName,
  )

  fields = _.sortBy(fields, ["groupId", "orderId"])

  const groups = _.uniq(fields.map((a) => a.groupId))
  const out = []

  groups.forEach((g) => {
    if (g) {
      out.push({
        title: g,
        type: "title",
        key: g,
        width: "100%",
      })
    }
    out.push(
      ...fields
        .filter((a) => a.groupId == g)
        .map((a) => {
          console.log("Custom field data", a)
          const c = Vue.prototype.$customFieldsToJson(
            data.customFieldValues || [],
          )
          c.code = c.code || c.fieldCode

          let type = a.type
          let contentType = a.contentType
          let options = a.options || []

          let searchFunction = a.searchFunction
          let value = c[a.code]

          if (contentType && contentType != "manual") {
            // console.log("Content type", contentType)
            const code = contentType
            searchFunction = async (text) => {
              const r = await api.getCatalogItems(
                text
                  ? {
                      type: code,
                      OR: [{ code_ilike: text }, { name_ilike: text }],
                    }
                  : { type: code },
                20,
                0,
                "id_asc",
              )

              return (r.list || []).map((i) => ({
                id: i.code,
                name: i.name,
                label: `${i.code} - ${i.name}`,
              }))
            }
            if (c[a.code]) {
              options = c[a.code]
            }
          }
          if (type == "multi-search" || type == "multi-select") {
            value = Array.isArray(c[a.code])
              ? c[a.code]
              : [c[a.code]].filter((i) => i)
          }
          return {
            title: a.name,
            key: "custom_" + a.code,
            value: value,
            type: type,
            width: type == "table" ? "100%" : "50%",
            required: a.required,
            columns: a.columns,
            selectList: options,
            group: g,
            searchFunction: searchFunction,
          }
        }),
    )
  })
  return out
}

Vue.prototype.$getFullAddress = (a = {}) => {
  var fullAddress = [
    [a.name, a.phone].join(" "),
    a.newAddress,
    a.newWard,
    a.newCity,
  ].join(", ")
  if (a.city) {
    fullAddress += ` (cũ: ${a.ward}, ${a.district}, ${a.city})`
  }
  return fullAddress
}
Vue.prototype.$formatAddress = (data = {}) => {
  const newCity =
    Vue.prototype.$provinces.find((a) => a.code == data.cusNewCity) || {}
  const newWard =
    Vue.prototype.$wards.find((a) => a.code == data.cusNewWard) || {}

  return {
    ...data,
    cusNewCity: newCity.name || data.cusNewCity,
    cusNewWard: newWard.name || data.cusNewWard,
  }
}

Vue.prototype.$addressInput = (d = {}, config = {}) => {
  const data = JSON.parse(JSON.stringify(d))
  const _this = Vue.prototype

  const customerAddresses = config.customerAddresses || []
  const mode = config.mode || "shipping" // main, shipping

  var newWards = []

  data.cusNewCity =
    (_this.$provinces.find((a) => a.name == data.newCity) || {}).code || ""

  newWards = _this.$wards
    .filter((a) => a.parentCode == data.cusNewCity)
    .map((w) => ({ id: w.code, name: w.name }))
  newWards = [{ id: "", name: "Không chọn" }, ...newWards]
  data.cusNewWard =
    (
      _this.$wards.find(
        (a) => a.name == data.cusNewWard && a.parentCode == data.cusNewCity,
      ) || {}
    ).code || ""

  data.cusCountry = data.cusCountry || "Việt Nam"
  const isVN = data.cusCountry == "Việt Nam"
  var customerAddressesList = customerAddresses.map((a) => {
    return {
      ...a,
      fullAddress: _this.$getFullAddress(a),
    }
  })

  data.cusAddress = data.cusNewAddress || data.cusAddress || data.address
  data.cusNewAddress = data.cusNewAddress || data.newAddress
  data.cusNewCity = data.cusNewCity || data.newCity
  data.cusNewWard = data.cusNewWard || data.newWard

  const list = [
    {
      title: "Danh sách địa chỉ khách hàng",
      key: "addressCustomer",
      width: "100%",
      type: "select",
      selectList: [
        { id: "save", name: "Thêm địa chỉ mới + lưu danh sách" },
        { id: "single", name: "Thêm địa chỉ lẻ" },
        ...customerAddressesList.map((a) => ({
          id: a.id,
          name: a.fullAddress,
        })),
      ],
      value: data.addressCustomer || "save",
      onChange: (e) => {
        var address = customerAddresses.find((a) => a.id == e) || {}

        _this.$formPopup.setData("cusAddress", address.address)
        _this.$formPopup.setData("cusName", address.name)
        _this.$formPopup.setData("cusPhone", address.phone)

        // for new address
        _this.$formPopup.setData("cusNewAddress", address.newAddress)

        const newCityId = (
          _this.$provinces.find((a) => a.name == address.newCity) || {}
        ).code

        _this.$formPopup.setData("cusNewCity", newCityId)
        const newWards = _this.$wards.filter((a) => a.parentCode == newCityId)
        const newWardId = (
          newWards.find((a) => a.name == address.newWard) || {}
        ).code

        _this.$formPopup.setData("cusNewWard", newWardId)
        _this.$formPopup.setAttr("cusNewWard", "selectList", newWards)

        if (e != "save" && e != "single") {
          // _this.$formPopup.setData("cusAddressType", "HOME")
        }
      },
    },
    {
      title: "Tên người nhận hàng",
      key: "cusName",
      value: data.cusName,
      width: "40%",
    },
    {
      title: "Số điện thoại người nhận",
      key: "cusPhone",
      value: data.cusPhone,
      width: "40%",
    },
    {
      title: "Loại địa chỉ",
      key: "cusType",
      value: data.cusType || "OFFICE",
      width: "20%",
      type: "select",
      selectList: [
        { id: "HOME", name: "Nhà riêng" },
        { id: "OFFICE", name: "Cơ quan" },
      ],
    },
    {
      title: "Quốc gia",
      key: "cusCountry",
      value: data.cusCountry || "Việt Nam",
      width: "100%",
      type: "select-search",
      selectList: [
        ..._this.$countries.map((a) => ({
          id: a.name,
          name: a.name,
        })),
      ],
      onChange: (e) => {
        if (e == "Việt Nam") {
          _this.$formPopup.setAttrs({
            cusNewCity: {
              type: "select-search",
              value: "",
              isHide: false,
            },
            cusNewWard: {
              type: "select-search",
              value: "",
              isHide: false,
            },
            cusNewAddress: {
              type: "text",
              value: "",
              isHide: false,
            },
          })
        } else {
          _this.$formPopup.setAttrs({
            cusNewCity: {
              type: "text",
              value: "",
              isHide: true,
            },
            cusNewWard: {
              type: "text",
              value: "",
              isHide: true,
            },
            cusNewAddress: {
              type: "text",
              value: "",
              isHide: true,
            },
          })
        }
      },
    },
    {
      title: "Tỉnh / Thành phố",
      key: "cusNewCity",
      value: data.cusNewCity,
      width: "50%",
      type: "select-search",
      selectList: _this.$provinces.map((p) => ({ id: p.code, name: p.name })),
      onChange: (e) => {
        var wards = _this.$wards
          .filter((a) => a.parentCode == e)
          .map((w) => ({ id: w.code, name: w.name }))
        wards = [{ id: "", name: "Không chọn" }, ...wards]
        _this.$formPopup.setData("cusNewWard", wards[0].id)
        _this.$formPopup.setAttr("cusNewWard", "selectList", wards)
      },
      isHide: !isVN,
    },

    {
      title: "Phường / xã",
      key: "cusNewWard",
      value: data.cusNewWard,
      width: "50%",
      type: "select-search",
      selectList: newWards || [],
      isHide: !isVN,
    },

    {
      title: isVN ? "Địa chỉ" : "Địa chỉ chi tiết",
      key: "cusNewAddress",
      value: data.cusNewAddress,
      width: "100%",
      isHide: !isVN,
    },
    {
      title: isVN ? "Địa chỉ (cũ)" : "Địa chỉ đầy đủ ",
      key: "cusAddress",
      value: data.cusAddress,
      width: "100%",
    },

    {
      title: "Ghi chú người nhận",
      key: "cusDescription",
      value: data.cusDescription,
      width: "100%",
      type: "textarea",
    },
  ]
  if (mode == "customer") {
    return list.filter(
      (a) =>
        a.key != "addressCustomer" &&
        a.key != "cusName" &&
        a.key != "cusPhone" &&
        a.key != "cusEmail" &&
        a.key != "cusZipCode" &&
        a.key != "cusAddressType" &&
        a.key != "cusDescription",
    )
  }
  return list
}

Vue.prototype.$customFieldsColumns = (tableName) => {
  let fields = Vue.prototype.$customFields.filter(
    (a) => a.tableName == tableName,
  )
  fields = _.sortBy(fields, ["groupId", "orderId"])

  return fields.map((a) => {
    return {
      key: "cf." + a.code,
      sortable: false,
      title: a.name,
      showData: (row) => {
        try {
          const customFields = Vue.prototype.$customFieldsToJson(
            row.customFieldValues || [],
          )

          if (a.type == "image") {
            return customFields[a.code]
              ? `<img class="avatar" src="${customFields[a.code]}" />`
              : "-"
          }
          if (a.type == "file") {
            const name = customFields[a.code]
              ? customFields[a.code].split("/").pop()
              : "-"
            return customFields[a.code]
              ? `<a href="${customFields[a.code]}" target="_blank">${name}</a>`
              : "-"
          }
          if (a.type == "files") {
            return (customFields[a.code] || []).length
              ? (customFields[a.code] || [])
                  .map((f) => {
                    const name = f ? f.split("/").pop() : "-"
                    return `<div><a href="${f}" target="_blank">${name}</a></div>`
                  })
                  .join("")
              : "-"
          }
          if (a.type == "images") {
            return (customFields[a.code] || []).length
              ? (customFields[a.code] || [])
                  .map((f) => {
                    return `<img class="avatar" src="${f}" />`
                  })
                  .join("")
              : "-"
          }
          if (a.type == "date") {
            return customFields[a.code]
              ? Vue.prototype.$formatDate(customFields[a.code])
              : "-"
          }
          if (a.type == "date-time") {
            return customFields[a.code]
              ? Vue.prototype.$formatFullDate(customFields[a.code])
              : "-"
          }

          if (a.type == "multi" || a.type == "multi-select") {
            return (customFields[a.code] || [])
              .map((item) => Vue.prototype.$getMultiFieldLabel(item))
              .filter(Boolean)
              .map((a) => `<span class="tag tag-sm">${a}</span>`)
              .join("")
          }

          if (
            a.type == "table" &&
            a.columns &&
            a.columns.length &&
            customFields[a.code]
          ) {
            a.width = "400px"
            return `<div class="">
              <table class="tb-child">
                <thead>
                  <tr>${a.columns
                    .map((col) => `<th>${col.title || "-"}</th>`)
                    .join("")}</tr>
                </thead>
                <tbody>
                  ${customFields[a.code]
                    .slice(0, 2)
                    .map(
                      (r) =>
                        `<tr>${a.columns
                          .map((col) => `<td>${r[col.id] || "-"}</td>`)
                          .join("")}</tr>`,
                    )
                    .join("")}
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="${a.columns.length}">+${
                      customFields[a.code].length
                    } </td>
                    </td>
                  </tr>
              </table>
            </div>`
          }
          if (a.type == "checkbox") {
            return customFields[a.code] ? "Có" : "Không"
          }
          if (a.type == "multi" || a.type == "multi-select") {
            return (customFields[a.code] || [])
              .map((item) => Vue.prototype.$getMultiFieldLabel(item))
              .filter(Boolean)
              .map((a) => `<span class="tag tag-sm">${a}</span>`)
              .join("")
          }
          return customFields[a.code] || "-"
        } catch {
          return "-"
        }
      },
      showDataRaw: (row) => {
        try {
          const customFields = Vue.prototype.$customFieldsToJson(
            row.customFieldValues || [],
          )
          if (a.type == "multi" || a.type == "multi-select") {
            return (customFields[a.code] || [])
              .map((item) => Vue.prototype.$getMultiFieldLabel(item))
              .filter(Boolean)
              .join(", ")
          }

          if (a.type == "table") {
            const columns = a.columns || []
            return (customFields[a.code] || [])
              .map((r) => {
                return columns
                  .map((col) => {
                    return r[col.id] || ""
                  })
                  .join(", ")
              })
              .join("\n")
          }
          if (a.type == "date") {
            return customFields[a.code]
              ? Vue.prototype.$formatDate(customFields[a.code])
              : ""
          }
          if (a.type == "date-time") {
            return customFields[a.code]
              ? Vue.prototype.$formatFullDate(customFields[a.code])
              : ""
          }
          return customFields[a.code]
        } catch {
          return ""
        }
      },
      searchKey: "cf." + a.code + "_ilike",
      searchType: a.type,
      width: a.width || "150px",
      searchList: a.content
        ? a.content.split("\n").map((b) => {
            return { id: b.trim(), name: b.trim() }
          })
        : [],
    }
  })
}

Vue.component("money-input", MoneyInput)
Vue.component("quantity-input", QuantityInput)
Vue.component("check-box", CheckBox)
Vue.component("data-table", DataTable)
Vue.component("data-table-local", DataTableLocal)
Vue.component("options", Options)
Vue.component("lines", Lines)
Vue.component("switch-input", Switch)
Vue.component("custom-fields", CustomFields)
Vue.component("radio", Radio)
Vue.component("barcode", VueBarcode)
Vue.component("auto-complete", AutoComplete)
Vue.component("downloadExcel", JsonExcel)
Vue.component("form-data", FormData)

Vue.directive("outside", {
  bind: function (el, binding) {
    const bubble = binding.modifiers.bubble
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler
    document.addEventListener("click", handler)
  },
  unbind: function (el) {
    document.removeEventListener("click", el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  },
})

Vue.directive("scroll", {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("mousewheel", f)
      }
    }
    window.addEventListener("mousewheel", f)
  },
})

export default {
  name: "app",
  data() {
    return {
      done: false,
      percent: 1,
    }
  },
  methods: {
    appHeight() {
      const doc = document.documentElement
      doc.style.setProperty("--app-height", `${window.innerHeight}px`)
    },
    logout() {
      localStorage.removeItem("token")
      localStorage.removeItem("branch")
      localStorage.removeItem("saleOrders")
      localStorage.removeItem("currentRoles")
      // this.$router.push("/login");
      location.reload()
    },
  },
  mounted: async function () {
    window.addEventListener("resize", this.appHeight)
    this.appHeight()
    if (localStorage.getItem("token")) {
      try {
        await resetData(
          "",
          (percent) => (this.percent = Math.floor((100 / 23) * percent)),
        )
        this.done = true
      } catch (e) {
        this.done = true
      }
    } else {
      this.done = true
    }

    this.$root.filterSide = this.$refs.filterSide
    this.$root.selectProduct = this.$refs.selectProduct
    this.$root.selectStock = this.$refs.selectStock
    this.$root.selectCustomer = this.$refs.selectCustomer
    this.$root.selectSupplier = this.$refs.selectSupplier
    this.$root.selectEmployee = this.$refs.selectEmployee
    this.$root.detail = this.$refs.detail
    this.$root.formPopup = this.$refs.formPopup
    Vue.prototype.$formPopup = this.$refs.formPopup
    this.$root.paymentOrderList = this.$refs.paymentOrderList

    this.$root.popup = this.$refs.popup

    Vue.prototype.$viewIncome = (data) => {
      this.$refs.quickViewIncome.openPopup(data)
    }
    Vue.prototype.$newIncome = (data, isEdit) => {
      this.$refs.newIncome.openPopup(data, isEdit)
    }
  },
  components: {
    Layout,
    ChatBot,
    ConfirmPopup,
    Notification,
    FormPopup,
    QuickView,
    FilterSide,
    SelectProduct,
    SelectCustomer,
    DetailQuickView,
    SelectEmployee,
    SelectSupplier,
    SelectStock,
    PaymentOrderList,
    QuickViewIncome,
    NewIncomeExpense,
    Popup,
  },
}
</script>

<style lang="scss">
@import "./assets/scss/main.scss";
</style>
